import { useEffect, useState } from "react";
import { castVote, fetchTally, retractVote } from "@/lib/votes";

export function useVotes(siteId) {
  const [tally, setTally] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let live = true;
    setTally(null);
    setErr(false);
    fetchTally(siteId)
      .then((t) => live && setTally(t))
      .catch(() => live && setErr(true));
    return () => {
      live = false;
    };
  }, [siteId]);

  const vote = async (i) => {
    if (busy) return;
    setBusy(true);
    try {
      setTally(tally?.mine === i ? await retractVote(siteId) : await castVote(siteId, i));
      setErr(false);
    } catch {
      setErr(true);
    } finally {
      setBusy(false);
    }
  };

  return { tally, err, busy, vote };
}

export function VoteRow({ i, votes }) {
  const { tally, err, busy, vote } = votes;
  const mine = tally?.mine === i;
  const total = tally?.total ?? 0;
  const n = tally?.counts?.[i] ?? 0;
  const pct = total ? Math.round((n / total) * 100) : 0;
  return (
    <div data-testid={`vote-row-${i}`} className="mt-4 border-t border-white/10 pt-3">
      <div className="flex items-center justify-between gap-3">
        <button
          data-testid={`vote-button-${i}`}
          onClick={() => vote(i)}
          disabled={busy || err}
          aria-pressed={mine}
          className={`flex items-center gap-2 rounded-full border px-3 py-1.5 font-mono text-[8px] tracking-[0.25em] transition-all duration-300 disabled:opacity-40 ${
            mine
              ? "border-[#FF9F1C] bg-[#FF9F1C] text-[#0B0C10]"
              : "border-white/20 text-white/55 hover:border-[#FF9F1C] hover:text-[#FF9F1C]"
          }`}
        >
          <span className={`h-1.5 w-1.5 rounded-full ${mine ? "bg-[#0B0C10]" : "bg-current"}`} />
          {mine ? "YOUR PICK" : "MOST CONVINCING"}
        </button>
        <span data-testid={`vote-pct-${i}`} className="font-mono text-[9px] tracking-[0.2em] text-white/45">
          {err ? "CROWD OFFLINE" : tally ? `${pct}% · ${n}` : "…"}
        </span>
      </div>
      <div className="mt-2 h-px w-full bg-white/10">
        <div
          data-testid={`vote-bar-${i}`}
          className={`h-px transition-all duration-700 ${mine ? "bg-[#FF9F1C]" : "bg-[#D4AF37]/70"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
